import { scroll, inView } from "motion";

const ContentScrollable = parent => {
  const wrapper = parent.querySelector(".snap-y");
  const children = wrapper.children;
    
  if (window.innerWidth < 992) {
    wrapper.style.height = children[0].offsetHeight + "px";
  }

  if (window.innerWidth >= 992) {
    const sectionHeight = children[0].offsetHeight;
    wrapper.style.top = (window.innerHeight + 20 + document.querySelector("#page-navbar").offsetHeight - sectionHeight) / 2 + "px";

    let currentItem = 0;

    parent.style.height = sectionHeight * children.length + "px";
    wrapper.style.height = sectionHeight + "px";

    const setMediaPlayState = (el, playing) => {
      el.querySelectorAll("video").forEach((video) => {
        if (playing) {
          video.play().catch(() => {});
        } else {
          video.pause();
        }
      });

      if (!playing) {
        el.querySelectorAll('iframe[src*="youtube.com/embed"]').forEach((iframe) => {
          iframe.contentWindow?.postMessage(
            JSON.stringify({ event: "command", func: "pauseVideo", args: [] }),
            "*"
          );
        });
      }
    };

    const updateCurrentItem = (_) => {
      if (
        typeof children[currentItem] != "undefined" &&
        children[currentItem]
      ) {
        Array.from(children).forEach((el) => {
          if (el !== children[currentItem]) {
            el.classList.remove("active");
            setMediaPlayState(el, false);
          }
        });

        children[currentItem].classList.add("active");
        setMediaPlayState(children[currentItem], true);
      }
    };

    updateCurrentItem();

    scroll(
      (scrollEvent) => {
        if (scrollEvent.y.progress > 0) {
          const currentOffset =
            scrollEvent.y.current - scrollEvent.y.offset[0];
          currentItem = Math.floor(currentOffset / sectionHeight);

          updateCurrentItem();
        }
      },
      {
        target: parent,
        offset: ["start center", "end end"],
      },
    );
  }
};

export default ContentScrollable;